namespace advisorop.domains {
    "use strict";

    export interface IMeetingAvailabilityScheduleInline {
        id?: number;

        type?: domains.MeetingType;

        day?: domains.DaysOfWeek;

        startTime: Date;

        endTime: Date;

        advisorId: number;

        unavailable?: boolean;
    }
}